import React from 'react'

function Featured() {
  return (
    <div>Featured</div>
  )
}

export default Featured